(function () {
  'use strict';

  var TIER_FROM = 2;

  // /cart.js exposes product_type, handle, vendor, product_id — but NOT tags.
  // Set STRAP_PRODUCT_TYPE to an exact value to match on that instead.
  var STRAP_PRODUCT_TYPE = '';
  var STRAP_HANDLE_RE    = /rubber/i;

  var strapQty = 0;
  var pending  = null;
  var dirty    = false;
  var observer = null;
  var rafId    = null;

  function isStrap(item) {
    if (STRAP_PRODUCT_TYPE) return item.product_type === STRAP_PRODUCT_TYPE;
    return STRAP_HANDLE_RE.test(item.handle || '');
  }

  function fetchStrapQty() {
    if (pending) { dirty = true; return pending; }

    pending = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        strapQty = (cart.items || [])
          .filter(isStrap)
          .reduce(function (n, i) { return n + i.quantity; }, 0);
      })
      .catch(function () { /* keep last known value */ })
      .then(function () {
        pending = null;
        paint();
        if (dirty) { dirty = false; fetchStrapQty(); }
      });

    return pending;
  }

  function selectedQty(el) {
    var scope =
      el.closest('form[action*="/cart/add"]') ||
      el.closest('[data-product-card], .card, .product-card') ||
      el.closest('.shopify-section') ||
      document;
    var input = scope.querySelector('[name="quantity"]');
    var n = parseInt(input && input.value, 10);
    return n > 0 ? n : 1;
  }

  function paint() {
    var nodes = document.querySelectorAll('[data-strap-price]');
    if (!nodes.length) return;

    if (observer) observer.disconnect();

    nodes.forEach(function (el) {
      var from = parseInt(el.dataset.tierFrom, 10) || TIER_FROM;
      var tier = (strapQty + selectedQty(el)) >= from ? 2 : 1;
      if (el.dataset.paintedTier === String(tier)) return;

      var priceEl = el.querySelector('[data-tier-price]');
      var labelEl = el.querySelector('[data-tier-label]');
      var hintEl  = el.querySelector('[data-tier-hint]');

      if (priceEl) priceEl.textContent = el.dataset['tier' + tier + 'Price'];
      if (labelEl) labelEl.textContent = '-' + el.dataset['tier' + tier + 'Percent'] + '%';
      if (hintEl)  hintEl.hidden = (tier === 2);

      el.dataset.paintedTier = String(tier);
    });

    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function schedulePaint() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = null; paint(); });
  }

  function init() {
    observer = new MutationObserver(schedulePaint);
    observer.observe(document.body, { childList: true, subtree: true });
    fetchStrapQty();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme publishes cart mutations on window.eventBus, not on document.
  (function bindBus(tries) {
    tries = tries || 0;
    if (!window.eventBus || typeof window.eventBus.on !== 'function') {
      if (tries > 100) return;
      return setTimeout(function () { bindBus(tries + 1); }, 50);
    }
    ['update:cart:drawer', 'render:cart:drawer'].forEach(function (evt) {
      window.eventBus.on(evt, fetchStrapQty);
    });
  })();

  // Dispatched manually by the upsell handler; coalesced with the bus events.
  document.addEventListener('cart:updated', fetchStrapQty);

  ['change', 'input'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && e.target.name === 'quantity') schedulePaint();
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('[name="plus"], [name="minus"], .quantity__button')) {
      schedulePaint();
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetchStrapQty();
  });
})();